import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Notifications from '../../../../../services/notifications';
import translate from '../../../../translate';
import ClearAllIcon from './icons/ClearAllIcon';
import NotificationList from './NotificationList';

function HeaderNotificationsPopup({ t, show }) {
  const listRef = useRef(null);

  const handleMarketAsRead = useCallback(async () => {
    try {
      await axios.get('/api/badge/read/notifications', {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        },
      });
      listRef.current.forceReload();
    } catch (error) {
      Notifications.showErrorFromRequest(
        error,
        t('notifications.failedToMarkAllAsRead'),
      );
    }
  }, []);

  return (
    <div className="m-dropdown__wrapper notifications-dropdown">
      <span className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" />
      <div className="m-dropdown__inner">
        <div
          className="m-dropdown__header notifications-header"
          style={{ background: '#ffffff' }}
        >
          <div className="notifications-header-title">
            {t('notifications.title')}
          </div>
          <button
            type="button"
            className="notifications-header-clear-button"
            onClick={handleMarketAsRead}
          >
            {t('notifications.markAllAsRead')}
            <ClearAllIcon />
          </button>
        </div>
        <div className="m-dropdown__body">
          {show && <NotificationList ref={listRef} />}
        </div>
      </div>
    </div>
  );
}

HeaderNotificationsPopup.propTypes = {
  t: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default translate(HeaderNotificationsPopup);
